import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { isVoid } from '@/utils/common';
import { fetchComponentBasicInfo } from '@/slices/execComponentSlice';
import Descriptions from '@/components/Descriptions';

function BasicInfo({ clusterId, basicInfo, envId, fetchComponentBasicInfo }) {
  const [searchParams] = useSearchParams();

  const id = searchParams.get('id');
  const { deployDir, productLibUrl, repoDir, reservedVersionNum, name } = basicInfo;

  useEffect(() => {
    if (!isVoid(clusterId)) {
      fetchComponentBasicInfo({ componentStencilId: id, envId, clusterId });
    }
  }, [clusterId, id, envId, fetchComponentBasicInfo]);

  return (
    !isVoid(clusterId) && (
      <Root>
        <Descriptions column={1}>
          <Descriptions.Item label='组件包安装在目标机器路径' value={deployDir} />
          <Descriptions.Item
            label='组件包存放在目标机器路径'
            value={`${repoDir}，在该目录下存放最近的${reservedVersionNum}个版本，可用来回滚`}
          />
          <Descriptions.Item label='物料包存放在' value={`${productLibUrl}${name}`} />
        </Descriptions>
      </Root>
    )
  );
}

export default connect(
  (state) => ({
    envId: state.execComponent.currentEnv.id,
    clusterId: state.execComponent.currentCluster.id,
    basicInfo: state.execComponent.basicInfo,
  }),
  {
    fetchComponentBasicInfo,
  },
)(BasicInfo);

const Root = styled.div`
  padding: 0 20px 10px;
`;
